export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfCxc4EsA.woff2";